// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2X164","dragIcon":"SortableItem_dragIcon__Z3wPr","disabled":"SortableItem_disabled__tfAwE"};